import { Action, createReducer, on } from '@ngrx/store';
import * as MemberSearchActions from './member-search.actions';
import { IMemberSearchState } from './member-search.model';

export const initialState: IMemberSearchState = {
  memberSearchCriteria: undefined,
  memberSearchResults: null,
  memberSearchResultsV2: null,
  currentPage: 1,
  sortCol: undefined,
  sortDir: undefined,
  pagePosition: 0,
  isLoading: false,
  pageSize: 10,
};

const reducer = createReducer(
  initialState,
  on(MemberSearchActions.searchMembers, (state, { memberSearchCriteria }) => ({
    ...state,
    memberSearchCriteria,
    isLoading: true,
    pageSize: 10
  })),
  on(MemberSearchActions.searchMembersSuccess, (state, { memberSearchResults }) => ({
    ...state,
    isLoading: false,
    memberSearchResults: memberSearchResults.map((result) => ({
      ...result,
      middleName: result?.middleName ? result.middleName[0] : ''
    }))
  })),
  on(MemberSearchActions.searchMembersFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    memberSearchResults: [],
    error
  })),
  on(MemberSearchActions.searchMembersV2, (state, { memberSearchCriteria }) => ({
    ...state,
    memberSearchCriteria,
    isLoading: true,
    pageSize: 10
  })),
  on(MemberSearchActions.searchMembersV2Success, (state, { memberSearchResults }) => ({
    ...state,
    isLoading: false,
    memberSearchResultsV2: memberSearchResults.map((result) => ({
      ...result,
      middleName: result?.middleName ? result.middleName[0] : ''
    }))
  })),
  on(MemberSearchActions.searchMembersV2Failure, (state, { error }) => ({
    ...state,
    isLoading: false,
    memberSearchResultsV2: [],
    error
  })),
  on(MemberSearchActions.resetSearchMembers, (state) => ({
    ...state,
    ...initialState,
    memberSearchResults: null,
    memberSearchResultsV2: null
  })),
  on(MemberSearchActions.setPagePosition, (state, { pagePosition }) => ({
    ...state,
    pagePosition
  })),
  on(MemberSearchActions.setCurrentResultsPage, (state, { pageNumber, sort }) => ({
    ...state,
    currentPage: pageNumber,
    sortCol: sort.col,
    sortDir: sort.dir
  })),
  on(MemberSearchActions.setPageSize, (state, { pageSize }) => ({
    ...state,
    pageSize,
  })),
  on(MemberSearchActions.resetSearchCriteria, (state) => ({
    ...state,
    memberSearchCriteria: undefined,
  })),
);

export function memberSearchReducer(state: IMemberSearchState | undefined, action: Action): IMemberSearchState {
  return reducer(state, action);
}
